import { makeStyles } from '@rbx/ui';

const useNotificationListStyles = makeStyles()((theme) => ({
  skeleton: {
    position: 'fixed',
    height: '100vh',
    display: 'flex',
    width: 500,
    flexDirection: 'column',
    right: 0,
    top: 0,
    zIndex: theme.zIndex.modal,
    [theme.breakpoints.down('Medium')]: {
      width: '100%',
    },
    pointerEvents: 'none',
  },

  skeletonTray: {
    flex: 1,
    overflow: 'hidden',
    marginTop: 60,
  },

  outerContainer: {
    pointerEvents: 'all',
    backgroundColor: theme.palette.surface[300],
    borderRadius: 12,
    flexGrow: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: 'calc(100% - 24px)',
    margin: 12,
    [theme.breakpoints.down('Medium')]: {
      height: '100%',
      margin: 0,
    },
  },

  listContainer: {
    flex: 1,
    paddingLeft: 6,
    paddingRight: 6,
    columnGap: 6,
    paddingTop: 6,
  },

  notificationContainer: {
    marginBottom: 6,
  },

  bottomLoader: {
    height: 60,
  },

  fullCenter: {
    flex: 1,
  },

  snackbarContainer: {
    position: 'absolute',
    width: '100%',
  },

  snackbarContent: {
    padding: '6px 16px 6px  16px',
    backgroundColor: theme.palette.info.main,
    color: theme.palette.content.inverse,
    borderRadius: 6,
    cursor: 'pointer',
  },

  scrollableY: {
    height: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    scrollbarColor: `${theme.palette.states.focusVisible} transparent`,
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.states.focusVisible,
      borderRadius: '10rem',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
  },
}));

export default useNotificationListStyles;
